import { SEAT_TYPE_CIRCLE } from '%paysera_seat_selection/js/seatSelection/config/constants';

export default function getYOffsetForSeat({ type, size }) {
    if (type !== SEAT_TYPE_CIRCLE) {
        return 0;
    }

    return -size / 2;
}
